import React, { useState } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import TestimonialHome from "../components/testimonialhhome";
import "react-phone-input-2/lib/style.css";

const contactCards = [
  {
    icon: "fas fa-phone-alt",
    title: "Call Us",
    value: "+971 2 644 6368",
    note: "Sun – Thu, 9:00 AM – 6:00 PM",
    href: "tel:+97126446368",
  },
  {
    icon: "fab fa-whatsapp",
    title: "WhatsApp",
    value: "+971 50 157 7822",
    note: "Chat directly with our experts",
    href: "https://wa.me/971501577822",
  },
  {
    icon: "far fa-envelope",
    title: "Email Us",
    value: "info@nvrealestate.ae",
    note: "We reply as quickly as possible",
    href: "mailto:info@nvrealestate.ae",
  },
  {
    icon: "fas fa-map-marker-alt",
    title: "Visit Our Office",
    value: "Sama Tower, Office 406",
    note: "Zayed The First St, Abu Dhabi",
    target:"_blank",
    href: "https://www.google.com/maps/dir//Nova+Vision+Real+Estate+LLC,+Sama+Tower+-+office+406+Zayed+The+First+St+-+Al+Danah+-+Zone+1+-+Abu+Dhabi/@24.4833507,54.3579144,17z/data=!4m17!1m7!3m6!1s0x3e5e67bc4fd96c6f:0x4c4766edcd59e19d!2sNova+Vision+Real+Estate+LLC!8m2!3d24.4833507!4d54.3604893!16s%2Fg%2F11x315nyf3!4m8!1m0!1m5!1m1!1s0x3e5e67bc4fd96c6f:0x4c4766edcd59e19d!2m2!1d54.3604893!2d24.4833507!3e0?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D",
  },
];

const stats = [
  { icon: "far fa-building", value: "500+", label: "Properties Available" },
  { icon: "fas fa-award", value: "10+", label: "Years of Experience" },
  { icon: "fas fa-users", value: "50+", label: "Real Estate Agents" },
  { icon: "fas fa-handshake", value: "500+", label: "Happy Clients" },
];

const testimonials = [
  {
    quote:
      "Excellent support throughout the purchase process. The team is very professional and transparent.",
    name: "Ahmed Al Mansoori",
  },
  {
    quote:
      "A professional team with deep knowledge of the Abu Dhabi market. Highly recommended.",
    name: "Fatima Al Suwaidi",
  },
  {
    quote:
      "NV Real Estate helped us find the perfect investment property. A genuinely smooth experience.",
    name: "John D.",
  },
];

const faqs = [
  {
    question: "How quickly do you respond?",
    answer:
      "Our team usually responds during business hours on the same day. WhatsApp is the quickest way to reach us.",
  },
  {
    question: "Can I schedule a property viewing?",
    answer:
      "Yes. Tell us the property or area you are interested in and we will arrange a suitable viewing time.",
  },
  {
    question: "Do you help with mortgages?",
    answer:
      "Yes. We provide free mortgage guidance and help coordinate your financing with the property purchase.",
  },
  {
    question: "Do you help overseas investors?",
    answer:
      "Yes. Our specialists support overseas buyers with shortlisting, virtual viewings, and the purchase process.",
  },
  {
    question: "Can you manage my property?",
    answer:
      "Yes. Contact our team to discuss leasing and property management support for your Abu Dhabi property.",
  },
];

function ContactUs() {
  const API = process.env.REACT_APP_API_URL || "https://nvrealestate.ae";
  const [formData, setFormData] = useState({
    agent_name: "",
    agent_phone: "",
    agent_email: "",
    interest: "",
    budget: "",
    location: "",
    agent_address: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({ text: "", type: "" });
  const [activeFaq, setActiveFaq] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((current) => ({ ...current, agent_phone: phone }));
    setErrors((current) => ({ ...current, agent_phone: "" }));
  };

  const validate = () => {
    const nextErrors = {};
    const phoneDigits = formData.agent_phone.replace(/\D/g, "");

    if (!formData.agent_name.trim()) nextErrors.agent_name = "Full name is required";
    if (!phoneDigits) nextErrors.agent_phone = "Phone number is required";
    else if (phoneDigits.length < 7 || phoneDigits.length > 15) {
      nextErrors.agent_phone = "Enter a valid phone number";
    }
    if (!formData.agent_email.trim()) nextErrors.agent_email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
      nextErrors.agent_email = "Enter a valid email address";
    }
    if (!formData.interest) nextErrors.interest = "Please select an option";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResponse({ text: "", type: "" });
    if (!validate()) return;

    setLoading(true);
    try {
      const details = [
        formData.agent_address,
        formData.interest && `Interest: ${formData.interest}`,
        formData.budget && `Budget: ${formData.budget}`,
        formData.location && `Preferred location: ${formData.location}`,
      ]
        .filter(Boolean)
        .join("\n");

      const payload = {
        proref: "Contact Us: Free Consultation",
        current_url: window.location.href,
        agent_name: formData.agent_name,
        agent_lname: "-",
        agent_phone: formData.agent_phone,
        agent_email: formData.agent_email,
        agent_address: details,
      };

      const result = await axios.post(
        `${API}/api/EnquiryHandlerStatic.ashx`,
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json" } }
      );

      setResponse({
        text: result.data?.message || "Thank you. Our property team will contact you shortly.",
        type: "success",
      });
      setFormData({
        agent_name: "",
        agent_phone: "",
        agent_email: "",
        interest: "",
        budget: "",
        location: "",
        agent_address: "",
      });
      setErrors({});
    } catch (error) {
      setResponse({ text: "Something went wrong. Please try again.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .nv-contact-page {
          --contact-primary: #293e95;
          --contact-heading: #09256d;
          --contact-dark: #071634;
          --contact-ink: #151b2b;
          --contact-muted: #667085;
          --contact-border: #e1e6ef;
          --contact-soft: #f4f6fc;
          color: var(--contact-ink);
          background: #fff;
        }

        .nv-contact-shell {
          width: min(1180px, calc(100% - 32px));
          margin: 0 auto;
        }

        .nv-contact-hero {
             position: relative;
    min-height: 530px;
    display: flex;
    align-items: center;
    overflow: hidden;
    color: #fff;
    background: linear-gradient(181deg, rgb(50 66 101 / 81%) 0%, rgb(6 22 55 / 68%) 42%, rgb(7 24 59 / 47%) 100%), url(/assets/images/abu.jpg) center 63% / cover no-repeat;
        }

        .nv-contact-hero::after {
          content: "";
          position: absolute;
          inset: auto 0 0;
          height: 120px;
          background: linear-gradient(transparent, rgba(5, 18, 45, .38));
          pointer-events: none;
        }

        .nv-contact-hero-copy {
          position: relative;
          z-index: 1;
          max-width: 680px;
          padding: 104px 0 128px;
        }

        .nv-contact-eyebrow {
          display: block;
          margin-bottom: 12px;
          color: #aebcff;
          font-size: 15px;
          font-weight: 800;
          letter-spacing: .16em;
          text-transform: uppercase;
        }

        .nv-contact-hero h1 {
          max-width: 650px;
          margin: 0 0 18px;
          color: #fff;
          font-size: clamp(42px, 5.6vw, 72px);
          line-height: .98;
          letter-spacing: -.045em;
        }

        .nv-contact-hero h1 span { color: #aebcff; }

        .nv-contact-hero p {
          max-width: 580px;
          margin: 0 0 28px;
          color: rgba(255,255,255,.9);
          font-size: 17px;
          line-height: 1.65;
        }

        .nv-contact-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .nv-contact-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-height: 50px;
          padding: 12px 22px;
          border: 1px solid var(--contact-primary);
          border-radius: 6px;
          background: var(--contact-primary);
          color: #fff;
          font-size: 13px;
          font-weight: 800;
          text-decoration: none;
          text-transform: uppercase;
          transition: .2s ease;
        }

        .nv-contact-btn:hover {
          transform: translateY(-2px);
          background: #1f317b;
          border-color: #1f317b;
          color: #fff;
        }

        .nv-contact-btn.outline {
          border-color: rgba(255,255,255,.68);
          background: rgba(255,255,255,.07);
          color: #fff;
        }

        .nv-contact-btn.outline:hover {
          background: #fff;
          border-color: #fff;
          color: var(--contact-primary);
        }

        .nv-contact-cards {
          position: relative;
          z-index: 3;
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 16px;
          margin-top: -64px;
        }

        .nv-contact-card {
          display: flex;
          align-items: center;
          gap: 15px;
          min-height: 126px;
          padding: 22px;
          border: 1px solid var(--contact-border);
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 16px 38px rgba(24, 35, 68, .11);
          color: inherit;
          text-decoration: none;
        }

        .nv-contact-card-icon {
          flex: 0 0 52px;
          width: 52px;
          height: 52px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: var(--contact-primary);
          color: #fff;
          font-size: 21px;
        }
.nv-contact-card-icon i{
color:white;}
        .nv-contact-card strong,
        .nv-contact-card > span:last-child,
        .nv-contact-card small { display: block; }
        .nv-contact-card .nv-contact-card-icon { display: grid; }
        .nv-contact-card strong { margin-bottom: 4px; font-size: 15px; }
        .nv-contact-card span { color: var(--contact-ink); font-size: 13px; font-weight: 700; }
        .nv-contact-card small { margin-top: 4px; color: var(--contact-muted); font-size: 11px; line-height: 1.45; }

        .nv-contact-main {
          display: grid;
          grid-template-columns: .94fr 1.06fr;
          gap: 34px;
          align-items: stretch;
          padding: 58px 0 26px;
        }

        .nv-contact-property {
          min-height: 570px;
          overflow: hidden;
          border-radius: 12px; 
          box-shadow: 0 16px 40px rgba(25, 38, 77, .12);
        }

        .nv-contact-form-wrap { padding: 4px 0; }

        .nv-contact-title h2 {
          margin: 0 0 12px;
          color: var(--contact-heading);
          font-size: 26px;
          line-height: 46px;
          letter-spacing: 0;
        }

        .nv-contact-title p {
          margin: 0 0 28px;
          color: #4a5b80;
          font-size: 15px;
          line-height: 1.7;
        }

        .nv-contact-form {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px 18px;
        }

        .nv-contact-field { min-width: 0; }
        .nv-contact-field.full { grid-column: 1 / -1; }

        .nv-contact-field label {
          display: block;
          margin-bottom: 7px;
          color: #293143;
          font-size: 12px;
          font-weight: 700;
        }

        .nv-contact-field input,
        .nv-contact-field select,
        .nv-contact-field textarea,
        .nv-contact-field .phone-input {
          width: 100% !important;
          min-height: 48px;
          padding: 11px 13px;
          border: 1px solid #d6dce7 !important;
          border-radius: 6px !important;
          background: #fff;
          color: var(--contact-ink);
          font-size: 13px;
          outline: none;
          box-shadow: none !important;
        }

        .nv-contact-field .react-tel-input .form-control { padding-left: 48px; }
        .nv-contact-field .react-tel-input .flag-dropdown {
          border: 1px solid #d6dce7;
          border-radius: 6px 0 0 6px;
          background: #f7f8fb;
        }

        .nv-contact-field textarea { min-height: 94px; resize: vertical; }
        .nv-contact-field input:focus,
        .nv-contact-field select:focus,
        .nv-contact-field textarea:focus {
          border-color: var(--contact-primary) !important;
          box-shadow: 0 0 0 3px rgba(41, 62, 149, .10) !important;
        }

        .nv-contact-field .input-error { border-color: #d92d20 !important; }
        .nv-contact-error { margin: 5px 0 0; color: #d92d20; font-size: 11px; }
        .nv-contact-response {
          grid-column: 1 / -1;
          margin: 0;
          padding: 10px 12px;
          border-radius: 5px;
          font-size: 13px;
        }
        .nv-contact-response.success { background: #ecfdf3; color: #027a48; }
        .nv-contact-response.error { background: #fef3f2; color: #b42318; }
        .nv-contact-submit { grid-column: 1 / -1; width: 100%; border: 0; cursor: pointer; }
        .nv-contact-submit:disabled { cursor: wait; opacity: .7; }

        .nv-contact-advisor-stats {
          display: grid;
          grid-template-columns: 1.65fr 2.35fr;
          overflow: hidden;
          margin: 0 0 34px;
          border: 1px solid var(--contact-border);
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 12px 34px rgba(24, 35, 68, .08);
        }

        .nv-contact-advisor {
          display: grid;
          grid-template-columns: 155px 1fr;
          align-items: end;
          min-height: 220px;
          border-right: 1px solid var(--contact-border);
        }

        .nv-contact-advisor img {
          width: 100%;
          max-height: 215px;
          object-fit: contain;
          object-position: bottom;
        }

        .nv-contact-advisor-copy { align-self: center; padding: 24px 20px 24px 0; }
        .nv-contact-advisor-copy h3 { margin: 0 0 10px; color: var(--contact-heading); font-size: 20px; line-height: 1.3; }
        .nv-contact-advisor-copy h4 { margin: 0 0 4px; color: var(--contact-primary); font-size: 18px; }
        .nv-contact-advisor-copy p { margin: 0 0 12px; color: var(--contact-muted); font-size: 12px; }
        .nv-contact-checks { margin: 0 0 14px; padding: 0; list-style: none; }
        .nv-contact-checks li { margin: 5px 0; font-size: 11px; }
        .nv-contact-checks i { margin-right: 7px; color: var(--contact-primary); }
        .nv-contact-advisor-actions { display: flex; gap: 8px; }
        .nv-contact-advisor-actions .nv-contact-btn { min-height: 38px; padding: 8px 13px; font-size: 10px; }
        .nv-contact-advisor-actions .outline { border-color: var(--contact-primary); color: var(--contact-primary); background: #fff; }

        .nv-contact-stats {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          align-items: stretch;
        }

        .nv-contact-stat {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px 10px;
          border-right: 1px solid var(--contact-border);
          text-align: center;
        }
        .nv-contact-stat:last-child { border-right: 0; }
        .nv-contact-stat i { margin-bottom: 13px; color: var(--contact-primary); font-size: 30px; }
        .nv-contact-stat strong { margin-bottom: 5px; color: #111827; font-size: 31px; line-height: 1; }
        .nv-contact-stat span { max-width: 95px; color: #30394b; font-size: 11px; font-weight: 700; line-height: 1.35; }

        .nv-contact-section-title {
          max-width: 760px;
          margin: 0 auto 28px;
          text-align: center;
        }
        .nv-contact-section-title h2 {
          margin: 0 0 12px;
          color: var(--contact-heading);
          font-size: 26px;
          line-height: 46px;
          letter-spacing: 0;
        }
        .nv-contact-section-title p {
          margin: 0;
          color: #4a5b80;
          font-size: 15px;
          line-height: 1.7;
        }

        .nv-contact-testimonials {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 18px;
          margin-bottom: 38px;
        }

        .nv-contact-review-section,
        .nv-contact-location-section {
          margin-bottom: 58px;
          margin-top: 58px;
        }

        .nv-contact-review-section .wrap-categories-sw {
          margin-bottom: 0;
        }

        .nv-contact-review {
          padding: 24px;
          border: 1px solid var(--contact-border);
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 8px 24px rgba(24, 35, 68, .06);
        }
        .nv-contact-stars { margin-bottom: 12px; color: var(--contact-primary); letter-spacing: 2px; }
        .nv-contact-review p { min-height: 62px; margin: 0 0 12px; color: #3d4658; font-size: 12px; line-height: 1.6; }
        .nv-contact-review strong { font-size: 11px; }

        .nv-contact-location-grid {
          display: grid;
          grid-template-columns: 1.25fr 1.25fr;
          gap: 18px;
          margin-bottom: 0;
        }

        .nv-contact-map,
        .nv-contact-office,
        .nv-contact-faq {
          overflow: hidden;
          min-height: 310px;
          border: 1px solid var(--contact-border);
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 8px 24px rgba(24, 35, 68, .06);
        }

        .nv-contact-map iframe { display: block; width: 100%; height: 100%; min-height: 310px; border: 0; }
        .nv-contact-office, .nv-contact-faq { padding: 24px; }
        .nv-contact-office h3, .nv-contact-faq h3 {
          margin: 0 0 12px;
          color: var(--contact-heading);
          font-size: 22px;
          line-height: 1.3;
        }
        .nv-contact-office > p { margin: 0 0 18px; color: #3d4658; font-size: 12px; line-height: 1.6; }
        .nv-contact-office-list { margin: 0 0 18px; padding: 0; list-style: none; }
        .nv-contact-office-list li { display: flex; gap: 9px; margin: 12px 0; color: #3d4658; font-size: 11px; line-height: 1.45; }
        .nv-contact-office-list i { width: 16px; color: var(--contact-primary); text-align: center; }
        .nv-contact-office .nv-contact-btn { min-height: 40px; padding: 8px 15px; font-size: 10px; }

        .nv-contact-faq-item { border: 1px solid var(--contact-border); border-radius: 5px; margin-bottom: 7px; }
        .nv-contact-faq-question {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 11px 12px;
          border: 0;
          background: #fff;
          color: var(--contact-ink);
          cursor: pointer;
          text-align: left;
          font-size: 11px;
          font-weight: 700;
        }
        .nv-contact-faq-question span { color: var(--contact-primary); font-size: 16px; }
        .nv-contact-faq-answer { display: none; padding: 0 12px 11px; }
        .nv-contact-faq-item.active .nv-contact-faq-answer { display: block; }
        .nv-contact-faq-answer p { margin: 0; color: var(--contact-muted); font-size: 11px; line-height: 1.55; }

        .nv-contact-bottom {
          padding: 34px 0;
          color: #fff;
          background:
            linear-gradient(90deg, rgba(5, 18, 46, .98), rgba(9, 28, 68, .90)),
            url("/assets/images/why.jpg") center / cover no-repeat;
        }
        .nv-contact-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 28px;
        }
        .nv-contact-bottom h2 { margin: 0 0 7px; color: #fff; font-size: 27px; }
        .nv-contact-bottom p { margin: 0; color: rgba(255,255,255,.8); font-size: 13px; }

        @media (max-width: 1050px) {
          .nv-contact-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .nv-contact-advisor-stats { grid-template-columns: 1fr; }
          .nv-contact-advisor { border-right: 0; border-bottom: 1px solid var(--contact-border); }
          .nv-contact-location-grid { grid-template-columns: 1fr 1fr; }
          .nv-contact-map { grid-column: 1 / -1; }
        }

        @media (max-width: 760px) {
          .nv-contact-hero { min-height: 500px; }
          .nv-contact-hero-copy { padding: 90px 0 115px; }
          .nv-contact-hero h1 { font-size: 43px; }
          .nv-contact-cards { grid-template-columns: 1fr; margin-top: -48px; }
          .nv-contact-main { grid-template-columns: 1fr; }
          .nv-contact-property { min-height: 390px; }
          .nv-contact-form { grid-template-columns: 1fr; }
          .nv-contact-field.full, .nv-contact-submit, .nv-contact-response { grid-column: auto; }
          .nv-contact-stats { grid-template-columns: repeat(2, 1fr); }
          .nv-contact-stat:nth-child(2) { border-right: 0; }
          .nv-contact-stat:nth-child(-n+2) { border-bottom: 1px solid var(--contact-border); }
          .nv-contact-testimonials, .nv-contact-location-grid { grid-template-columns: 1fr; }
          .nv-contact-map { grid-column: auto; }
          .nv-contact-bottom-inner { align-items: flex-start; flex-direction: column; }
        }

        @media (max-width: 480px) {
          .nv-contact-shell { width: min(100% - 22px, 1180px); }
          .nv-contact-actions, .nv-contact-bottom .nv-contact-actions { flex-direction: column; width: 100%; }
          .nv-contact-actions .nv-contact-btn { width: 100%; }
          .nv-contact-advisor { grid-template-columns: 125px 1fr; }
          .nv-contact-advisor-copy { padding-right: 12px; }
          .nv-contact-advisor-actions { flex-direction: column; }
        }
      `}</style>

      <main className="nv-contact-page">
        <section className="nv-contact-hero">
          <div className="nv-contact-shell">
            <div className="nv-contact-hero-copy">
              <span className="nv-contact-eyebrow">Get in touch</span>
              <h1>
                Contact Abu Dhabi’s <span>Property Experts</span>
              </h1>
              <p>
                Whether you’re buying, selling, renting, or investing, our specialists
                are ready to guide you with clear, local expertise.
              </p>
              <div className="nv-contact-actions">
                <a className="nv-contact-btn" href="tel:+97126446368">
                  <i className="fas fa-phone-alt" /> Call Now
                </a>
                <a
                  className="nv-contact-btn outline"
                  href="https://wa.me/971501577822"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-whatsapp" /> WhatsApp Us
                </a>
                <a className="nv-contact-btn outline" href="#contact-form">
                  <i className="far fa-calendar-alt" /> Book Consultation
                </a>
              </div>
            </div>
          </div>
        </section>

        <div className="nv-contact-shell">
          <section className="nv-contact-cards" aria-label="Contact options">
            {contactCards.map((card) => (
              <a
                className="nv-contact-card"
                href={card.href}
                key={card.title}
                target={card.href.startsWith("http") ? "_blank" : undefined}
                rel={card.href.startsWith("http") ? "noreferrer" : undefined}
              >
                <span className="nv-contact-card-icon"><i className={card.icon} /></span>
                <span>
                  <strong>{card.title}</strong>
                  <span>{card.value}</span>
                  <small>{card.note}</small>
                </span>
              </a>
            ))}
          </section>

          <section className="nv-contact-main" id="contact-form">
              <div className="nv-contact-map">
              <iframe
                title="Nova Vision Real Estate office location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2241.1236132290996!2d54.35930582623172!3d24.483469019358008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e67bc4fd96c6f%3A0x4c4766edcd59e19d!2sNova%20Vision%20Real%20Estate%20LLC!5e0!3m2!1sen!2sin!4v1778233987291!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="nv-contact-form-wrap">
              <header className="nv-contact-title">
                <h2>Send Us a Message</h2>
                <p>Fill in the form and our team will get back to you shortly.</p>
              </header>

              <form className="nv-contact-form" onSubmit={handleSubmit} noValidate>
                <div className="nv-contact-field">
                  <label htmlFor="contact-name">Full Name *</label>
                  <input
                    id="contact-name"
                    name="agent_name"
                    value={formData.agent_name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className={errors.agent_name ? "input-error" : ""}
                  />
                  {errors.agent_name && <p className="nv-contact-error">{errors.agent_name}</p>}
                </div>

                <div className="nv-contact-field">
                  <label htmlFor="contact-phone">Phone Number *</label>
                  <PhoneInput
                    country="ae"
                    value={formData.agent_phone}
                    onChange={handlePhoneChange}
                    inputClass={`phone-input ${errors.agent_phone ? "input-error" : ""}`}
                    containerClass="phone-container"
                    enableSearch
                    inputProps={{ id: "contact-phone" }}
                  />
                  {errors.agent_phone && <p className="nv-contact-error">{errors.agent_phone}</p>}
                </div>

                <div className="nv-contact-field">
                  <label htmlFor="contact-email">Email Address *</label>
                  <input
                    id="contact-email"
                    type="email"
                    name="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className={errors.agent_email ? "input-error" : ""}
                  />
                  {errors.agent_email && <p className="nv-contact-error">{errors.agent_email}</p>}
                </div>

                <div className="nv-contact-field">
                  <label htmlFor="contact-interest">I am interested in *</label>
                  <select
                    id="contact-interest"
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    className={errors.interest ? "input-error" : ""}
                  >
                    <option value="">Select an option</option>
                    <option>Buying a property</option>
                    <option>Renting a property</option>
                    <option>Selling my property</option>
                    <option>Property investment</option>
                    <option>Mortgage advice</option>
                    <option>Property management</option>
                  </select>
                  {errors.interest && <p className="nv-contact-error">{errors.interest}</p>}
                </div>

                <div className="nv-contact-field">
                  <label htmlFor="contact-budget">Budget Range</label>
                  <select id="contact-budget" name="budget" value={formData.budget} onChange={handleChange}>
                    <option value="">Select your budget</option>
                    <option>Below AED 1M</option>
                    <option>AED 1M – 2M</option>
                    <option>AED 2M – 5M</option>
                    <option>AED 5M – 10M</option>
                    <option>AED 10M+</option>
                  </select>
                </div>

                <div className="nv-contact-field">
                  <label htmlFor="contact-location">Preferred Location</label>
                  <select
                    id="contact-location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  >
                    <option value="">Select location</option>
                    <option>Yas Island</option>
                    <option>Saadiyat Island</option>
                    <option>Al Reem Island</option>
                    <option>Al Raha Beach</option>
                    <option>Masdar City</option>
                    <option>Other</option>
                  </select>
                </div>

                <div className="nv-contact-field full">
                  <label htmlFor="contact-message">Message</label>
                  <textarea
                    id="contact-message"
                    name="agent_address"
                    value={formData.agent_address}
                    onChange={handleChange}
                    placeholder="Tell us more about your requirements..."
                  />
                </div>

                {response.text && (
                  <p className={`nv-contact-response ${response.type}`} role="status">
                    {response.text}
                  </p>
                )}

                <button className="nv-contact-btn nv-contact-submit" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Get Free Consultation"}
                </button>
              </form>
            </div>
          </section>
 
          <section className="nv-contact-review-section" aria-labelledby="contact-reviews-title">
            <header className="nv-contact-section-title">
              <h2 id="contact-reviews-title">What Our Clients Say</h2>
              <p>Trusted guidance from first conversation to final handover.</p>
            </header>
           <TestimonialHome />
          </section>

          <section className="nv-contact-location-section" aria-labelledby="contact-office-title">
            <header className="nv-contact-section-title">
              <h2 id="contact-office-title">OFFICE ADDRESS</h2>
              <p>Find us at our office and connect with ease where support and solutions come together.</p>
            </header>
            <div className="nv-contact-location-grid" id="contact-office">
     
          

            <div className="nv-contact-office">
              <h3>Our Office</h3>
              <p>Sama Tower, Office 406<br />Zayed The First St, Al Danah<br />Abu Dhabi, UAE</p>
              <ul className="nv-contact-office-list">
                <li><i className="fas fa-car" /><span><strong>Parking:</strong> Available in Sama Tower visitor parking</span></li>
                <li><i className="fas fa-subway" /><span><strong>Location:</strong> Central Abu Dhabi, Al Danah</span></li>
                <li><i className="far fa-clock" /><span><strong>Working hours:</strong> Sun – Thu, 9:00 AM – 6:00 PM</span></li>
              </ul>
              <a
                className="nv-contact-btn"
                href="https://www.google.com/maps/dir//Nova+Vision+Real+Estate+LLC,+Sama+Tower+-+office+406+Zayed+The+First+St+-+Al+Danah+-+Zone+1+-+Abu+Dhabi/@24.4833507,54.3579144,17z/data=!4m17!1m7!3m6!1s0x3e5e67bc4fd96c6f:0x4c4766edcd59e19d!2sNova+Vision+Real+Estate+LLC!8m2!3d24.4833507!4d54.3604893!16s%2Fg%2F11x315nyf3!4m8!1m0!1m5!1m1!1s0x3e5e67bc4fd96c6f:0x4c4766edcd59e19d!2m2!1d54.3604893!2d24.4833507!3e0?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noreferrer"
              >
                Get Directions
              </a>
            </div>

            <div className="nv-contact-faq">
              <h3>Frequently Asked Questions</h3>
              {faqs.map((item, index) => {
                const isActive = activeFaq === index;
                return (
                  <article className={`nv-contact-faq-item${isActive ? " active" : ""}`} key={item.question}>
                    <button
                      type="button"
                      className="nv-contact-faq-question"
                      onClick={() => setActiveFaq((current) => (current === index ? null : index))}
                      aria-expanded={isActive}
                    >
                      {item.question}
                      <span>{isActive ? "−" : "+"}</span>
                    </button>
                    <div className="nv-contact-faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  </article>
                );
              })}
            </div>
            </div>
          </section>
        </div>

        <section className="nv-contact-bottom">
          <div className="nv-contact-shell nv-contact-bottom-inner">
            <div>
              <h2>Ready to Find Your Dream Property?</h2>
              <p>Speak with our experts today and get personalised guidance.</p>
            </div>
            <div className="nv-contact-actions">
              <a className="nv-contact-btn" href="#contact-form">
                <i className="far fa-calendar-alt" /> Schedule a Call
              </a>
              <a
                className="nv-contact-btn outline"
                href="https://wa.me/971501577822"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-whatsapp" /> WhatsApp Now
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ContactUs;
